var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPending(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 0C7.392 0 0 7.392 0 16.5C0 25.608 7.392 33 16.5 33C25.608 33 33 25.608 33 16.5C33 7.392 25.608 0 16.5 0ZM8.25 18.975C6.8805 18.975 5.775 17.8695 5.775 16.5C5.775 15.1305 6.8805 14.025 8.25 14.025C9.6195 14.025 10.725 15.1305 10.725 16.5C10.725 17.8695 9.6195 18.975 8.25 18.975ZM16.5 18.975C15.1305 18.975 14.025 17.8695 14.025 16.5C14.025 15.1305 15.1305 14.025 16.5 14.025C17.8695 14.025 18.975 15.1305 18.975 16.5C18.975 17.8695 17.8695 18.975 16.5 18.975ZM24.75 18.975C23.3805 18.975 22.275 17.8695 22.275 16.5C22.275 15.1305 23.3805 14.025 24.75 14.025C26.1195 14.025 27.225 15.1305 27.225 16.5C27.225 17.8695 26.1195 18.975 24.75 18.975Z",
    fill: "#FF8A00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/pending.3d44c00d7a09f965ca7076ea7098559a.svg";
export { ForwardRef as ReactComponent };